import { statusHandler } from './statusHandler';
import { useMutation } from 'react-query';
import { defaultReactQueryOptions } from './getCustomQueryClientOptions';
import { ConfirmObj } from '../interfaces/AccountDataTypes';
import { useNavigate } from 'react-router-dom';

export const usePostConfirmationData = (setSuccessMessage: (successMessage: string) => void) => {
    const navigate = useNavigate();

    return useMutation((values: ConfirmObj) => statusHandler(fetch, '/public/confirm', 'POST', values), {
        ...defaultReactQueryOptions,
        onSuccess: (apiResp: { message: string }) => {
            setSuccessMessage(apiResp.message);
            navigate('/login');
        },
        onError: () => {},
    });
};
